import * as React from "react";
const SvgFiRrTablePivot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M24 16v1c0 2.757-2.243 5-5 5h-1a1 1 0 1 1 0-2h1c1.654 0 3-1.346 3-3v-1a1 1 0 1 1 2 0m0-9v2a1 1 0 1 1-2 0H7v11h4a1 1 0 1 1 0 2H5c-2.757 0-5-2.243-5-5V7c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5M2 7h3V4C3.346 4 2 5.346 2 7m3 2H2v8c0 1.654 1.346 3 3 3zm17-2c0-1.654-1.346-3-3-3H7v3zm-7.127 11H17c1.654 0 3-1.346 3-3v-2.127l.293.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-1.075-1.076c-.871-.871-2.391-.871-3.263 0l-1.076 1.076a.999.999 0 1 0 1.414 1.414l.293-.293V15c0 .552-.449 1-1 1h-2.127l.293-.293a.999.999 0 1 0-1.414-1.414l-1.075 1.076A2.3 2.3 0 0 0 12.001 17c0 .616.24 1.196.676 1.631l1.076 1.076a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414z"
    />
  </svg>
);
export default SvgFiRrTablePivot;
